import React, { useState, useEffect } from 'react';
import { THEME } from '../../utils/theme';
import api from '../../utils/api';

const AutoSessionsBanner = ({ onConfirm, onDismiss }) => {
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [processing, setProcessing] = useState({});

  useEffect(() => {
    api.get('/api/integrations/sessions/auto')
      .then(data => setSessions(data.sessions || []))
      .catch(() => setSessions([]))
      .finally(() => setLoading(false));
  }, []);

  const handleConfirm = async (sessionId) => {
    setProcessing(p => ({ ...p, [sessionId]: 'confirming' }));
    try {
      await api.post(`/api/integrations/sessions/auto/${sessionId}/confirm`);
      setSessions(s => s.filter(sess => sess.id !== sessionId));
      if (onConfirm) onConfirm();
    } catch (err) {
      alert('Failed to confirm: ' + err.message);
    }
    setProcessing(p => ({ ...p, [sessionId]: null }));
  };

  const handleDismiss = async (sessionId) => {
    setProcessing(p => ({ ...p, [sessionId]: 'dismissing' }));
    try {
      await api.post(`/api/integrations/sessions/auto/${sessionId}/dismiss`);
      setSessions(s => s.filter(sess => sess.id !== sessionId));
      if (onDismiss) onDismiss();
    } catch (err) {
      alert('Failed to dismiss: ' + err.message);
    }
    setProcessing(p => ({ ...p, [sessionId]: null }));
  };

  if (loading || sessions.length === 0) return null;

  return (
    <div style={{ background: `linear-gradient(135deg, ${THEME.omega}15, ${THEME.supe}15)`, border: `1px solid ${THEME.info}40`, borderRadius: '14px', padding: '16px', margin: '16px 24px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '12px' }}>
        <span style={{ fontSize: '20px' }}>🎮</span>
        <h3 style={{ margin: 0, color: THEME.text, fontSize: '14px', fontWeight: '600' }}>Recent Play Sessions Detected</h3>
        <span style={{ background: THEME.info, color: '#000', padding: '2px 8px', borderRadius: '10px', fontSize: '11px', fontWeight: '600' }}>{sessions.length}</span>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
        {sessions.slice(0, 3).map(session => (
          <div key={session.id} style={{ display: 'flex', alignItems: 'center', gap: '12px', background: THEME.bgCard, borderRadius: '10px', padding: '12px' }}>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ color: THEME.text, fontWeight: '600', fontSize: '13px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {session.game_name}
              </div>
              <div style={{ color: THEME.textMuted, fontSize: '11px' }}>
                {session.duration_minutes} min • {new Date(session.detected_at).toLocaleDateString()}
              </div>
            </div>
            <button
              onClick={() => handleConfirm(session.id)}
              disabled={processing[session.id]}
              style={{ background: THEME.success, color: '#000', border: 'none', borderRadius: '8px', padding: '8px 12px', fontSize: '12px', fontWeight: '600', cursor: 'pointer' }}
            >
              {processing[session.id] === 'confirming' ? '...' : '✓ Log'}
            </button>
            <button
              onClick={() => handleDismiss(session.id)}
              disabled={processing[session.id]}
              style={{ background: THEME.bgHover, color: THEME.textMuted, border: `1px solid ${THEME.border}`, borderRadius: '8px', padding: '8px 12px', fontSize: '12px', fontWeight: '500', cursor: 'pointer' }}
            >
              {processing[session.id] === 'dismissing' ? '...' : '✕'}
            </button>
          </div>
        ))}
      </div>
      {sessions.length > 3 && (
        <div style={{ color: THEME.textMuted, fontSize: '11px', textAlign: 'center', marginTop: '8px' }}>
          +{sessions.length - 3} more sessions
        </div>
      )}
    </div>
  );
};

export default AutoSessionsBanner;
